export default "__VITE_ASSET__D7NJU81f__"